module.exports = __webpack_public_path__ + "static/media/4P.91e96391.svg";